import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'living_location'

const answers: AnswerType[] = [
  {
    emoji: '🏙️',
    title: 'pages.onboarding.livingLocation.options.cityCenter',
    value: 'city-center',
  },
  {
    emoji: '🏘️',
    title: 'pages.onboarding.livingLocation.options.suburbs',
    value: 'suburbs',
  },
  {
    emoji: '🌄',
    title: 'pages.onboarding.livingLocation.options.countryside',
    value: 'countryside',
  },
]

export default function LivingLocationPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && answers.some((answer) => answer.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const value = input.value

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Where do you live?',
      answer_key: value,
      answer: value,
    }
    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.livingLocation.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
